import React, { ReactNode } from 'react';
import { useSdkInitialization } from 'src/hooks/useSdkInitialization';

interface SdkWrapperProps {
  children: ReactNode;
}

export function SdkWrapper({ children }: SdkWrapperProps): JSX.Element {
  const { isSdkInitialized } = useSdkInitialization();

  if (!isSdkInitialized) {
    return null;
  }

  return <>{children}</>;
}
